import React from 'react';
import {
  useContractActuals,
  getCaStats,
  percentageLeft,
  ContractActualsProvider,
} from './contract_actuals/state_mgmt';
import Big from 'big.js';

const ContractActualsContainer = props => {
  return (
    <>
      <ContractActualsProvider {...props}>
        <RenderContractActuals />
      </ContractActualsProvider>
    </>
  );
};

const RenderContractActuals = () => {
  const [state] = useContractActuals();
  let isValid = Big(percentageLeft(state)).eq(0.0);
  return (
    <>
      {state.contractActuals.map((contractActual, index) => {
        return <ContractActual key={index} index={index} contractActual={contractActual} />;
      })}
      {isValid ? (
        ''
      ) : (
        <p className="text-red-600" data-cy={`pc-percentage-error-${state.policy_contract.id}`}>
          {' '}
          The sum of all the actual percentages needs to eq{' '}
          {state.policy_contract.default_percentage}{' '}
        </p>
      )}
    </>
  );
};

const ContractActual = ({ index, contractActual }) => {
  let [limit, premium] = getCaStats(contractActual);
  return (
    <>
      <div
        className="flex flex-col mt-3"
        data-cy={`ca-container-${contractActual.carrier_contract_id}`}>
        <div className="flex items-start" data-cy="carrier-name">
          <strong className="font-light text-lg">{contractActual.carrier_name}</strong>
        </div>
        <div className="flex flex-row mt-2" data-cy="actual-percentage">
          <div className="flex flex-col items-start w-1/2">
            <PercentageField index={index} contractActual={contractActual} />
          </div>
          <div className="flex w-1/2">
            <div className="flex flex-col items-start px-4" data-cy="default-percentage">
              <strong className="text-base font-light">Default</strong>
              <div className="font-bold font-semibold">{contractActual.default_percentage}%</div>
            </div>
            <div className="flex flex-col items-start pr-2" data-cy="limit">
              <strong className="text-base font-light">Limit</strong>
              <div className="font-bold font-semibold"> {limit} </div>
            </div>
            <div className="flex flex-col items-end ml-auto" data-cy="premium">
              <strong className="text-base font-light">Premium</strong>
              <div className="font-bold font-semibold"> {premium} </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const PercentageField = ({ contractActual, index }) => {
  let [state, dispatch] = useContractActuals();
  const { pc_index } = state;
  // let max = percentageLeft(state);
  let actualName = `policy[policy_contracts_attributes][${pc_index}][contract_actuals_attributes][${index}][actual]`;
  let idName = `policy[policy_contracts_attributes][${pc_index}][contract_actuals_attributes][${index}][id]`;
  let carrierContractIdName = `policy[policy_contracts_attributes][${pc_index}][contract_actuals_attributes][${index}][carrier_contract_id]`;

  const setActualValue = ({ target: { value } }) => {
    dispatch({
      type: 'update_actual_percentage',
      payload: { actual: value, actualIndex: index },
    });
  };

  return (
    <>
      <label className="text-base">Actual</label>
      <input
        data-cy={`carrier_contract_${contractActual.carrier_contract_id}_contract_actual_input`}
        className="text-base"
        defaultValue={contractActual.actual}
        onChange={setActualValue}
        type="number"
        step="any"
        min="0"
        name={actualName}
        max={state.policy_contract.default_percentage}
      />
      <input type="hidden" name={idName} defaultValue={contractActual.id} />
      <input
        type="hidden"
        name={carrierContractIdName}
        defaultValue={contractActual.carrier_contract_id}
      />
    </>
  );
};

export default ContractActualsContainer;
